import {PrivateInterceptor} from "../../../Base/interceptors/PrivateInterceptor";


// ENVIAR NOTIFICACION REQUISA PENDIENTE DE AUTORIZAR
export const tiposArchivosRequisa = () => {
    const respuesta = PrivateInterceptor('tipos/archivoRequisa', 'GET');
    return respuesta;
}

export const getArchivosRequisa = (IdRequisa) => {
    const respuesta = PrivateInterceptor(`archivos/requisas`, 'POST', {IdRequisa});
    return respuesta;
}

export const postArchivosRequisa = (data) => {
    const respuesta = PrivateInterceptor(`archivos/nuevoArchivo`, 'POST', data);
    return respuesta;
}

export const deleteArchivosRequisa = (data) => {
    const respuesta = PrivateInterceptor(`archivos/eliminarArchivo`, 'POST', data);
    return respuesta;
}

export const getDataArchivo  = (IdFile) => {
    const respuesta = PrivateInterceptor(`archivos/dataArchivo`, 'POST', {IdFile});
    return respuesta;
}